import '../../resources/css/common/ModalAlert.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { closeModalAlert } from '../../actions/index';

class ModalAlert extends Component {

  closeModal = () => {
    const { closeModalAlert, callback } = this.props;
    closeModalAlert();

    setTimeout(() => {
      if (callback) {
        callback();
      }
    }, 50);
  }

  render() {
    const { isAlertShow, alertTitle, alertText } = this.props;

    let renderContent;
    if (isAlertShow) {
      renderContent = (
        <Modal
            show={isAlertShow}
            dialogClassName='modal-alert'
            centered
        >
          <Modal.Body>
            <div className='area-modal-alert-header'>
                <label>{alertTitle?alertTitle:'Alert'}</label>
            </div>
            <div className='area-modal-alert-content'>
              <br />
              <span className='icon-notice'></span>
              <br />
              <label className='area-modal-alert-text'>{alertText}</label>
              <hr />
              <div className='area-btn'>
                <Button type="button" variant="primary" className='btn-ok' onClick={this.closeModal}>OK</Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )
    } else {
      renderContent = (<div className='modal-detail-empty'></div>);
    }

    return (
      <div className='area-modal-alert'>
          {renderContent}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isAlertShow: state.commonReducers.isAlertShow,
    alertText: state.commonReducers.alertText,
    alertTitle: state.commonReducers.alertTitle,
    callback: state.commonReducers.callback
  }
}

export default connect(
  mapStateToProps,
  { closeModalAlert }
)(ModalAlert)